import React, {FC} from "react"

import Button from "@irati/ui/src/Button/Button"
import {H2} from "@irati/ui/src/Typography"
import GenericModal from "@irati/ui/src/GenericModal"
import Flex from "@irati/ui/src/Flex"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import Spinner from "@irati/ui/src/Loading/Spinner"
import FormattedMessage from "@irati/utils/lang"

interface Props {
  showModal: boolean
  onClose: () => void
  onNext: () => void
}

const ApproveOrderModal: FC<Props> = ({showModal, onClose, onNext}) => {
  return (
    <GenericModal
      show={showModal}
      onHide={onClose}
      actions={
        <Flex gap={2} direction="column" marginTop={3}>
          <Button primary onClick={onNext}>
            <FormattedMessage id="admin.components.orderManagement.approveOrder.nextOrder" />
          </Button>
        </Flex>
      }>
      <H2 textAlign="center" marginBottom={3}>
        <FormattedMessage id="admin.components.orderManagement.approveOrder.approving" />
      </H2>
      <Loading load={hangPromise()} Loader={() => <Spinner size="lg" />} />
    </GenericModal>
  )
}

export default ApproveOrderModal
